
export const profile = {
  title: 'Your Personality Profile',
  type: 'Personality Type',
  traits: 'Key Traits',
  workStyle: 'Work Style',
  communication: 'Communication Style',
  basedOnWords: 'Based on {{count}} selected words',
  behavioralFactors: 'Behavioral Factors',
  objectivityFactor: 'Style Factor',
  subjective: 'Subjective',
  objective: 'Objective'
};

export const chart = {
  percentile: 'th percentile',
  average: 'Average',
  scale: {
    low: 'Low',
    middle: 'Average', 
    high: 'High'
  }
};

export const traits = {
  assertive: 'Assertive',
  collaborative: 'Collaborative',
  outgoing: 'Outgoing',
  reserved: 'Reserved',
  steady: 'Steady',
  dynamic: 'Dynamic',
  structured: 'Structured',
  flexible: 'Flexible',
  analytical: 'Analytical',
  intuitive: 'Intuitive',
  visionary: 'Visionary',
  teamOriented: 'Team-oriented',
  systematic: 'Systematic',
  relationshipBuilder: 'Relationship builder',
  teamBuilder: 'Team builder',
  consistentPerformer: 'Consistent performer',
  diplomaticLeader: 'Diplomatic leader',
  changeResistant: 'Change-resistant',
  naturalLeader: 'Natural leader',
  persuasiveCommunicator: 'Persuasive communicator',
  resultsFocused: 'Results-focused',
  adaptableToChange: 'Adaptable to change',
  relationshipFocused: 'Relationship-focused',
  structuredApproach: 'Structured approach',
  influential: 'Influential',
  networkBuilder: 'Network builder',
  resultsDriven: 'Results-driven',
  systematicLeader: 'Systematic leader',
  strategicThinker: 'Strategic thinker',
  patientInnovator: 'Patient innovator',
  peopleFocused: 'People-focused',
  patientLeader: 'Patient leader',
  measuredRiskTaker: 'Measured risk-taker',
  sustainableInnovator: 'Sustainable innovator',
  technicalExpert: 'Technical expert',
  detailOriented: 'Detail-oriented',
  qualityFocused: 'Quality-focused',
  selfSufficient: 'Self-sufficient',
  goalOriented: 'Goal-oriented',
  persistent: 'Persistent',
  selfMotivated: 'Self-motivated',
  processMinded: 'Process-minded',
  selfReliant: 'Self-reliant',
  quickDecisionMaker: 'Quick decision maker',
  taskFocused: 'Task-focused',
  comfortableWithAmbiguity: 'Comfortable with ambiguity',
  decisive: 'Decisive',
  efficient: 'Efficient',
  direct: 'Direct',
  nurturing: 'Nurturing',
  organized: 'Organized',
  inclusive: 'Inclusive',
  processOriented: 'Process-oriented',
  loyal: 'Loyal',
  patient: 'Patient',
  encouraging: 'Encouraging',
  reliable: 'Reliable',
  enthusiastic: 'Enthusiastic',
  persuasive: 'Persuasive',
  optimistic: 'Optimistic',
  social: 'Social',
  spontaneous: 'Spontaneous',
  creative: 'Creative',
  energetic: 'Energetic',
  methodical: 'Methodical',
  thorough: 'Thorough',
  diplomatic: 'Diplomatic',
  consistent: 'Consistent',
  peaceful: 'Peaceful',
  versatile: 'Versatile',
  easyGoing: 'Easy-going',
  supportive: 'Supportive',
  adaptable: 'Adaptable',
  wellRounded: 'Well-rounded',
  situational: 'Situational'
};

export const personality = {
  inspirationalLeader: {
    type: 'Luminary',
    description: 'Charismatic leader who builds structured, stable teams and drives organizational excellence'
  },
  commander: {
    type: 'Commander',
    description: 'Strong leader who values both relationships and stability, creating lasting organizational impact'
  },
  executive: {
    type: 'Executive',
    description: 'Commanding and influential leader who drives results through people and strategic thinking'
  },
  dynamicNetworker: {
    type: 'Closer',
    description: 'High-energy relationship builder who drives change through structured networking and systematic influence'
  },
  visionaryLeader: {
    type: 'Charger',
    description: 'Commanding leader who drives innovation through structured vision and systematic execution'
  },
  socialInnovator: {
    type: 'Uniter',
    description: 'Patient relationship builder who creates change through collaborative innovation and people-focused solutions'
  },
  strategicEntrepreneur: {
    type: 'Builder',
    description: 'Patient yet decisive leader who builds sustainable innovation through strategic thinking and measured risk-taking'
  },
  specialist: {
    type: 'Catalyst',
    description: 'Expert who prefers structured, independent work while maintaining high standards of quality and precision'
  },
  achiever: {
    type: 'Achiever',
    description: 'Results-driven individual who values consistency and systematic approaches to goal accomplishment'
  },
  pioneer: {
    type: 'Pioneer',
    description: 'Independent achiever who prefers direct action and thrives in unstructured, challenging environments'
  },
  independent: {
    type: 'Independent',
    description: 'Self-motivated individual who prefers autonomy and direct action while maintaining high personal standards'
  },
  teamBuilder: {
    type: 'Connector',
    description: 'Relationship-focused leader who creates structured, inclusive environments where everyone can thrive'
  },
  supporter: {
    type: 'Supporter',
    description: 'People-focused team player who values stability and creates lasting, meaningful professional relationships'
  },
  influencer: {
    type: 'Spark',
    description: 'People-focused motivator who embraces change and inspires others through enthusiasm and positive energy'
  },
  networker: {
    type: 'Networker',
    description: 'Collaborative and outgoing, you excel at building relationships and bringing people together'
  },
  systematizer: {
    type: 'Systematizer',
    description: 'Process-oriented individual who values quality, consistency, and systematic approaches to work excellence'
  },
  facilitator: {
    type: 'Steady',
    description: 'Steady team member who maintains harmony, builds consensus, and creates collaborative work environments where everyone feels valued'
  },
  collaborator: {
    type: 'Collaborator',
    description: 'Flexible team player who adapts seamlessly to any situation while maintaining positive team dynamics'
  },
  harmonizer: {
    type: 'Harmonizer',
    description: 'Adaptable individual who maintains balance in all situations while fostering positive relationships and organizational stability'
  },
  professional: {
    type: 'Professional',
    description: 'Demonstrates well-rounded traits across all behavioral dimensions with adaptable professional approach'
  }
};
